import { apiSlice } from './apiSlice';

/**
 * Заряд машины времени — топливо симуляции (backend `TimeEnergyService`).
 *
 * Единица — посадко-день: столько же, сколько стоит один день реплея одной
 * посадки. Поэтому «сколько дней я могу прожить» зависит не только от баланса,
 * но и от того, сколько посадок сейчас в огороде, — цифру без контекста читать
 * бессмысленно, и главный экран показывает её вместе с потолком запаса.
 */
export type EnergyBalance = {
  /** Текущий запас в посадко-днях. */
  balance: number;
  /** Действующий потолок посадок аккаунта (база + заработанное). */
  plantingCap: number;
  /** Сколько посадко-дней капает в сутки. */
  dailyGrant: number;
  /** Потолок запаса — выше не начисляется и не доливается. */
  stockCap: number;
};

type EnergyResponse = { success: boolean; data: EnergyBalance };

export const energyApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getEnergyBalance: builder.query<EnergyBalance, void>({
      query: () => ({ url: '/energy' }),
      transformResponse: (resp: EnergyResponse) => resp?.data,
    }),
  }),
  overrideExisting: false,
});

export const { useGetEnergyBalanceQuery } = energyApi;
export default energyApi;
